import { useState, useMemo } from "react";
import { cn } from "../../../../../../util/cn";
import SubscriptionCard from "./SubscriptionCard";
import DialogWrapper from "../../../../../custom-ui/dialog/Dialog_NewUI";
import MonthlyPlanPrePaymentModal from "./MonthlyPlanPrePaymentModal";
import SpeakWithAccountExecutiveModal from "./SpeakWithAccountExecutiveModal";
import SpeakWithAccountExecutiveThankYouModal from "./SpeakWithAccountExecutiveThankYouModal";
import { stripePlansPrices } from "../../../../../../util/stripe/stripeUtils";
import ContactSalesSupport from "./ContactSalesSupport_Alternative";

type PlansProps = {
  currentSubscription: string;
  onContinue: (subscriptionText: string) => void;
};

const PlansPage = ({ currentSubscription = "", onContinue }: PlansProps) => {
  const [selectedSubscription, setSelectedSubcription] = useState(null);
  const [isMonthlyPrePaymentModalVisible, setIsMonthlyPrePaymentModalVisible] = useState(false);
  const [isAnnualPrePaymentModalVisible, setIsAnnualPrePaymentModalVisible] = useState(false);
  const [
    isAnnualSpeakWithAccountExecutiveModalVisible,
    setIsAnnualAccountExecutiveLeads,
  ] = useState(false);
  const [
    isAnnualSpeakWithAccountExecutiveThankYouModalVisible,
    setIsAnnualSpeakWithAccountExecutiveThankYouModalVisible,
  ] = useState(false);

  // const filteredSubscriptions = useMemo(() => {
  //   return subscriptions.filter((subscription) => {
  //     if (currentSubscription === "single") return true;
  //     return subscription.type !== currentSubscription;
  //   });
  // }, [currentSubscription]);

  const filteredSubscriptions = useMemo(() => {
    // if currentSubscription is NOT passed → show all
    if (!currentSubscription) {
      return subscriptions;
    }

    if (currentSubscription === "single") {
      return subscriptions;
    }

    // if user already has a subscription → show only "single" + annual plans
    return subscriptions.filter(
      (subscription) =>
        subscription.type === "single" || subscription.type === "annual"
    );
  }, [currentSubscription]);


  const closeMonthlyPrePaymentModal = () => {
    setIsMonthlyPrePaymentModalVisible(false);
  };

  const closeAnnualPrePaymentModal = () => {
    setIsAnnualPrePaymentModalVisible(false);
  };

  const closeAnnualSpeakWithAccountExecutiveModal = () => {
    setIsAnnualAccountExecutiveLeads(false);
  };

  const handleContinue = (subscriptionType = "") => {

    if (subscriptionType === "single") {
      onContinue(subscriptionType);
    } else if (subscriptionType === "monthly") {
      setIsMonthlyPrePaymentModalVisible(true);
    }
    else if (subscriptionType === "annual12" || subscriptionType === "annual24") {
      setIsAnnualPrePaymentModalVisible(true);
    } else {
      setIsAnnualAccountExecutiveLeads(true);
    }
  };

  const onCancelMonthlyPlanPrePayment = () => {
    setIsMonthlyPrePaymentModalVisible(false);
  };
  const onCancelAnnualPlanPrePayment = () => {
    setIsAnnualPrePaymentModalVisible(false);
  };

  const onProceedMonthlyPlanPrePayment = () => {
    onContinue(selectedSubscription);
  };

  const onCancelAnnualSpeakWithAccountExecutiveModal = () => {
    setIsAnnualAccountExecutiveLeads(false);
  };

  const onSubmitAnnualSpeakWithAccountExecutiveModal = () => {
    setIsAnnualSpeakWithAccountExecutiveThankYouModalVisible(true);
  };

  const closeAnnualSpeakWithAccountExecutiveThankYouModal = () => {
    setIsAnnualSpeakWithAccountExecutiveThankYouModalVisible(false);
  };

  const onSubmitAnnualSpeakWithAccountExecutiveThankYouModal = () => {
    setIsAnnualSpeakWithAccountExecutiveThankYouModalVisible(false);
    onContinue("null");
  };

  return (
    <>

      <div className="flex w-full flex-col">

        <ContactSalesSupport
          onContactSales={() => {
            setSelectedSubcription("annual");
            handleContinue("annual");
          }}
        />
        {/* {filteredSubscriptions.map((subscription: any) => {
            return (
              <SubscriptionCard
                key={subscription.type}
                type={subscription.type}
                title={subscription.title}
                subTitle={subscription.subTitle}
                price={subscription.price}
                // isSelected={selectedSubscription === subscription.type}
                isSelected={false}
                // onClick={() => setSelectedSubcription(subscription.type)}
                onContinue={() => {
                  setSelectedSubcription(subscription.type);
                  handleContinue(subscription.type);
                }}
              />
            );
          })} */}

        {/* 
        <button
          className={cn(
            "mt-[40px] w-[260px] h-[60px] rounded-[70px] py-[20px] px-[70px] flex flex-row justify-center items-center text-[#FFFFFF]",
            {
              "bg-[#8AA0AE]": !selectedSubscription,
              "bg-[#15415E]": selectedSubscription,
            },
          )}
          disabled={!selectedSubscription}
          onClick={handleContinue}
        >
          Continue
        </button> */}
      </div>

      {isMonthlyPrePaymentModalVisible && (
        <DialogWrapper
          title="&nbsp;"
          onClose={closeMonthlyPrePaymentModal}
          displayCloseIcon={true}
          displayHeaderHorizontalLine={false}
          size="max-w-[630px]"
        >
          <MonthlyPlanPrePaymentModal
            onCancel={onCancelMonthlyPlanPrePayment}
            onProceed={onProceedMonthlyPlanPrePayment}
          />
        </DialogWrapper>
      )}


      {isAnnualPrePaymentModalVisible && (
        <DialogWrapper
          title="&nbsp;"
          onClose={closeAnnualPrePaymentModal}
          displayCloseIcon={true}
          displayHeaderHorizontalLine={false}
          size="max-w-[630px]"
        >
          <MonthlyPlanPrePaymentModal
            onCancel={onCancelAnnualPlanPrePayment}
            selectedSubscription={selectedSubscription}
            onProceed={onProceedMonthlyPlanPrePayment}
          />
        </DialogWrapper>
      )}

      {isAnnualSpeakWithAccountExecutiveModalVisible && (
        <DialogWrapper
          title="Get In Touch"
          subtitle="Our team is here to help you. Send us a message and we'll get back to you as soon as possible."
          onClose={closeAnnualSpeakWithAccountExecutiveModal}
          displayCloseIcon={true}
          displayHeaderHorizontalLine={true}
          size="w-[calc(100%-1.5rem)] max-w-[480px]"
          panelClassName="!p-5"
        >
          <SpeakWithAccountExecutiveModal
            onCancel={onCancelAnnualSpeakWithAccountExecutiveModal}
            onDone={onSubmitAnnualSpeakWithAccountExecutiveModal}
            type="request"
            source="annualSubscriptionRenewal"
          />
        </DialogWrapper>
      )}

      {isAnnualSpeakWithAccountExecutiveThankYouModalVisible && (
        <DialogWrapper
          title=""
          onClose={closeAnnualSpeakWithAccountExecutiveThankYouModal}
          displayCloseIcon={true}
          displayHeaderHorizontalLine={true}
          size="max-w-[680px]"
        >
          <SpeakWithAccountExecutiveThankYouModal
            onDone={onSubmitAnnualSpeakWithAccountExecutiveThankYouModal}
          />
        </DialogWrapper>
      )}
    </>
  );
};

export default PlansPage;

const subscriptions = [
  {
    type: "single",
    title: "Single",
    subTitle: "Fuel Your Talent <br/> Pipeline with Ease",
    price: `$${stripePlansPrices.single}`,
  },
  {
    type: "monthly",
    title: "Monthly",
    subTitle: "Empower Your Hiring Strategy, Month After Month",
    price: `$${stripePlansPrices.monthly}`,
  },

  {
    type: "annual12",
    title: "Annual Flex Subscription",
    subTitle: "29 Job Postings",
    price: `$${stripePlansPrices.annual12}`,
  },

  {
    type: "annual24",
    title: "Annual Flex Subscription",
    subTitle: "29 Job Postings",
    price: `$${stripePlansPrices.annual24}`,
  },
  {
    type: "annual",
    title: "Annual Custom",
    subTitle: "Your Gateway to Strategic Hiring Success",
    price: "",
  },

];
